const middleware = {}

middleware['fixed-routes'] = require('../middleware/fixed-routes.js')
middleware['fixed-routes'] = middleware['fixed-routes'].default || middleware['fixed-routes']

middleware['navigation'] = require('../middleware/navigation.js')
middleware['navigation'] = middleware['navigation'].default || middleware['navigation']

export default middleware
